import { createSlice } from "@reduxjs/toolkit";
import { getSafetyData } from "../reduxApi/safetyDataReduxApi";

const safetyDataSlice =createSlice({
    name:'safetyData',
    initialState:{
        status:'idel',
        safetyData:[],
    },
    reducers:{
        deletesafetyDataAction:(state,action)=>{
            action.payload.forEach((ROWID) => {
                const index =state.safetyData.findIndex((item)=> item.ROWID === ROWID);
                if(index != -1){
                    state.safetyData.splice(index,1);
                }
            });
        },
        updatesafetyDataAction:(state,action) =>{
            console.log("action",action.payload.ROWID)
            const index=state.safetyData.findIndex((item)=> item.ROWID === action.payload.ROWID)
            if(index != -1){
            state.safetyData.splice(index,1,action.payload)
            }
        },
        addsafetyDataAction: (state, action) => {
            console.log("Adding safety data:", action.payload);
            const temp = action.payload.formData;
            temp.ROWID = action.payload.ROWID;
            state.safetyData.unshift(temp);
           
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getSafetyData.pending, (state, action) => {
            state.status = 'pending'
        })
            .addCase(getSafetyData.fulfilled, (state, action) => {
                state.status = 'fulfilled'
                console.log("testing safety Data", action.payload)
                state.safetyData = action.payload.data.safetyDataResp
;
            })
    }
})
export const {deletesafetyDataAction ,updatesafetyDataAction,addsafetyDataAction}=safetyDataSlice.actions
export default safetyDataSlice.reducer